import React from 'react'

const Menu = ({
  className = '',
  width = '1em',
  height = '1em',
  ...props
}) => (
  <svg className={`ac-icon ac-icon__menu ${className}`} width={width} height={height} {...props} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.5 5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h17zm-17 6h17a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm0 6h17a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/>
  </svg>
)

export default Menu
